import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-sample-code-box',
    templateUrl: './sample-code-box.component.html',
    styleUrls: ['./sample-code-box.component.scss']
})
export class SampleCodeBoxComponent implements OnInit {

    public Title: string = ''
    public SampleCode: string = ''

    constructor(
        private dialogRef: MatDialogRef<SampleCodeBoxComponent>,
        @Inject(MAT_DIALOG_DATA) public data) {

        if (data) {
            this.Title = data;
        }
    }

    ngOnInit(): void {

    }

    CanAddNewMeasure() {
        return this.SampleCode && this.SampleCode !== ''
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        this.dialogRef.close(this.SampleCode);
    }
}
